import { NumberOnlyDirectiveModule } from './../@fuse/directives/number-only.directive.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { Error500Module } from './modules/error/error-500/error-500.module';
import { Error404Module } from './modules/error/error-404/error-404.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ComponentsModule } from './layout/common/components/components.module';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe, DecimalPipe } from '@angular/common';
import { CurrencyFormetDirectivesModule } from '@fuse/directives/Currency-Formet/currency-formet.module';


const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
};

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        CurrencyFormetDirectivesModule,
        NumberOnlyDirectiveModule,

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        MatSnackBarModule,
        MatDatepickerModule,
        MatMomentDateModule,
        // Core module of your application
        CoreModule,
        ComponentsModule,
        // Layout module of your application
        LayoutModule,
        Error404Module,
        Error500Module,
        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),
    ],
    bootstrap: [AppComponent],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        DatePipe,
        DecimalPipe
    ]
})
export class AppModule { }
